import { render, staticRenderFns } from "./exchannels.vue?vue&type=template&id=3eadafa0&scoped=true"
import script from "./exchannels.vue?vue&type=script&lang=js"
export * from "./exchannels.vue?vue&type=script&lang=js"
import style0 from "./exchannels.vue?vue&type=style&index=0&id=3eadafa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eadafa0",
  null
  
)

export default component.exports